import SchoolInformationPreview from './SchoolInformationPreview.component';

export default SchoolInformationPreview;
